import { OctTextField } from '@oceantech/oceantech-ui';
import { ChangeEvent, useState } from 'react';
import ModalChonKetQuaDichVu from './ModalChonKetQuaDichVu';

type Props = {
	buttonLabel?: string;
	disabled?: boolean;
	value: string;
	onChange: (value: string) => void;
	patientInfo: {
		visitId: string;
	};
	className?: string;
};

const ParaclinicalSummaryField = ({
	value,
	onChange,
	disabled,
	buttonLabel = 'Chọn kết quả',
	patientInfo,
	className,
}: Props) => {
	const [openSelectDialog, setOpenSelectDialog] = useState(false);

	return (
		<div className={className}>
			<button
				className="btn btn-link py-0 d-flex ms-auto"
				type="button"
				onClick={() => {
					setOpenSelectDialog(true);
				}}
				disabled={disabled}
			>
				<u className="fw-bold text-pri">{buttonLabel}</u>
			</button>
			<OctTextField
				name="paraclinicalSummary"
				as="textarea"
				rows={3}
				className="resize-none w-100"
				value={value}
				onChange={(e: ChangeEvent<HTMLInputElement>) => {
					onChange(e.target.value);
				}}
			/>

			{openSelectDialog && (
				<ModalChonKetQuaDichVu
					open={openSelectDialog}
					handleClose={() => setOpenSelectDialog(false)}
					onSave={(selectedData: any[] = []) => {
						if (!selectedData.length) {
							onChange('');
							return;
						}

						const stringResult = selectedData
							.map((item) => {
								const serviceResult = item.ketQua ? `(${item.ketQua})` : '';
								return `${item.tenDichVu} ${serviceResult}`;
							})
							.join(', ');
						onChange(stringResult);
					}}
					visitId={patientInfo.visitId}
				/>
			)}
		</div>
	);
};

export default ParaclinicalSummaryField;
